import { useState, useMemo, useEffect } from 'react';
import CartClient from 'clients/cart';
import { getCountryCode, getLanguageCode } from 'utilities/locales';
import {
  eligibleProductPromotions,
  getTopPromoEligibility,
} from 'components/pages/product/helpers';

export const usePromotionEligibility = (cart, currentProduct) => {
  const [promoEligibility, setPromoEligibility] = useState({});
  const cartNumber = cart?.number;

  const cartClient = useMemo(
    () => new CartClient(cartNumber, getCountryCode(), getLanguageCode()),
    [cartNumber],
  );

  useEffect(() => {
    const promosByPriority = eligibleProductPromotions(currentProduct?.slug);

    getTopPromoEligibility(promosByPriority, cartClient, (eligibility) => {
      eligibility && setPromoEligibility(eligibility);
    });
  }, [currentProduct?.slug, cartClient]);

  return { promoEligibility };
};
